// features/client/client.validation.js

export const validation = {
  first_name: (value) => {
    if (!value?.trim()) return "First name is required";
    if (value.trim().length < 2)
      return "First name must be at least 2 characters";
    return "";
  },

  last_name: () => "",

  email: (value) => {
    if (!value?.trim()) return "Email is required";

    const emailRegex =
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(value))
      return "Invalid email format";

    return "";
  }, 
  phone: (value) => {
    if (!value) return ""; 
    if (!/^[+0-9\s-]{10,10}$/.test(value))
      return "Phone number must be 10 digits";
    return "";
  }, 

  city: () => "",

  country_directory_fid: (value) => {
    if (!value) return "Country is required";
    return "";
  },

  location: () => "",

  company_fid: (value) => {
    if (!value) return "Company is required";
    return "";
  },

  designation_fid: () => "",

  // admin_fids: (value) => {
  //   if (!Array.isArray(value) || value.length === 0)
  //     return "Please select at least one manager";
  //   return "";
  // },
  user_role_fid: (value) => {
    if (!value) return "User Role is required";
    return "";
  }
};